import styled from 'styled-components/macro';

export const IconWrapper = styled.span`
  display: inline-block;

  padding: 2px;
  border-radius: 2px;

  cursor: pointer;

  transition: all 0.1s ease;
  :hover {
    background-color: ${({ theme }) => theme.colors.black_5};

    transition: all 0.2s ease;
    svg path {
      transition: all 0.2s ease;

      stroke: ${({ theme }) => theme.colors.black_100};
    }
  }
`;

export const IconsWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;
